import { API_URL } from '../../../app-config/constants';
import { ActivationEvent } from '../../../types/ActivationEvent';
import { get } from '../request';

type Params = {
    from: string;
    to: string;
};

const addTempId = <A extends ActivationEvent>(event: A): A => ({
    ...event,
    id: [event.userA, event.userB, event.when].join(':'),
});

getEvents.operation = 'READ';
export function getEvents(params: Params) {
    return get<ActivationEvent[]>(`${API_URL}/analytics/events`, { getData: params }).then(events =>
        events.map(addTempId)
    );
}

getEventsForCompany.operation = 'READ';
export function getEventsForCompany(companyId: string, params: Params) {
    return get<ActivationEvent[]>(`${API_URL}/co/analytics/events`, { getData: { companyId, ...params } }).then(
        events => events.map(addTempId)
    );
}
